import(/* webpackMode: "eager" */ "/vercel/path0/apps/terminal/app/home/page.tsx");
